// src/components/CompetitionInfo.js
import React from 'react';
import {
    Box,
    Typography,
    Grid,
    Chip,
    Divider,
    Paper
} from '@mui/material';

export default function CompetitionInfo({ competition, isAdminView }) {
    const formatDate = (date) => {
        return new Date(date).toLocaleDateString('et-EE', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    return (
        <Box>
            <Paper elevation={0} sx={{ p: 2, bgcolor: 'background.default' }}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography variant="h5" fontWeight="bold" gutterBottom>
                            {competition.name}
                        </Typography>
                    </Grid>



                    <Grid item xs={12}>
                        <Divider />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                            Location
                        </Typography>
                        <Typography variant="body1">
                            📍 {competition.location}
                        </Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                            Organizer
                        </Typography>
                        <Typography variant="body1">
                            {competition.organizer}
                        </Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                            Start Date
                        </Typography>
                        <Typography variant="body1">
                            📅 {formatDate(competition.startDate)}
                        </Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                            End Date
                        </Typography>
                        <Typography variant="body1">
                            📅 {formatDate(competition.endDate)}
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    {competition.description && (
                        <Grid item xs={12}>
                            <Typography
                                variant="body1"
                                color="textSecondary"
                                sx={{ whiteSpace: 'pre-line' }}
                            >
                                {competition.description}
                            </Typography>
                        </Grid>
                    )}

                    <Grid item xs={12}>
                        <Divider />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                            Competition Type
                        </Typography>
                        <Chip
                            label={
                                competition.isTeamCompetition
                                    ? `Team Competition (${competition.teamSize} members)`
                                    : 'Individual Competition'
                            }
                            color="primary"
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                            Participants
                        </Typography>
                        <Typography variant="body1">
                            {competition.registrations?.length || 0} / {competition.maxParticipants}
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                            Competition Categories
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            {competition.categories.map((category, index) => (
                                <Chip key={index} label={category} variant="outlined" />
                            ))}
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <Divider />
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                            Scoring System
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Typography variant="body2">
                                • First place points: <strong>{competition.scoringSystem.firstPlacePoints}</strong>
                            </Typography>
                            <Typography variant="body2">
                                • Points decrement per position: <strong>{competition.scoringSystem.decrementBy}</strong>
                            </Typography>
                            <Typography variant="body2">
                                • Scoring direction: <strong>
                                {competition.scoringSystem.higherIsBetter ? 'Higher is Better' : 'Lower is Better'}
                            </strong>
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <Chip
                            label={
                                competition.allowSelfScoring
                                    ? "✓ Self-scoring enabled"
                                    : "✗ Self-scoring disabled"
                            }
                            color={competition.allowSelfScoring ? "success" : "default"}
                            variant="outlined"
                        />
                    </Grid>
                </Grid>
            </Paper>
        </Box>
    );
}